var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoEvent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 105,
    viewBox: "0 0 119 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.66 36.4197C71.29 36.4197 62.7699 36.0797 54.7999 33.8597C46.9799 31.6897 39.7999 27.4797 33.3999 22.6097C29.2099 19.4397 25.3999 16.9197 19.9599 17.2997C14.6335 17.5913 9.54234 19.5899 5.43995 22.9997C-1.48005 28.9997 -0.440053 40.2297 2.32995 48.1197C6.48995 59.9997 19.1499 68.2297 29.9099 73.6097C42.3399 79.8197 55.9999 83.4197 69.6899 85.4997C81.6899 87.3197 97.1099 88.6497 107.51 80.8097C117.06 73.6097 119.68 57.1697 117.34 46.0697C116.773 42.7876 115.027 39.8255 112.43 37.7397C105.72 32.8397 95.7099 36.1097 88.1699 36.2797C85.3699 36.3397 82.52 36.4097 79.66 36.4197Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.18 104.949C79.4543 104.949 95.89 103.924 95.89 102.659C95.89 101.394 79.4543 100.369 59.18 100.369C38.9056 100.369 22.47 101.394 22.47 102.659C22.47 103.924 38.9056 104.949 59.18 104.949Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54006 72.4307C7.0813 72.4307 7.52006 71.9919 7.52006 71.4507C7.52006 70.9095 7.0813 70.4707 6.54006 70.4707C5.99882 70.4707 5.56006 70.9095 5.56006 71.4507C5.56006 71.9919 5.99882 72.4307 6.54006 72.4307Z",
    fill: "#CFCFCF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.78 84.8594V89.1694",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.63 87.0195H50.93",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.41 17H17.9401C15.8083 17 14.0801 18.7282 14.0801 20.86V77.43C14.0801 79.5618 15.8083 81.29 17.9401 81.29H100.41C102.542 81.29 104.27 79.5618 104.27 77.43V20.86C104.27 18.7282 102.542 17 100.41 17Z",
    fill: "white",
    stroke: "#F0F0F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.77 21.0009V27.4114L14.58 27.5004L14.58 21.0009L14.58 20.9996C14.5788 20.5576 14.6649 20.1197 14.8332 19.7111C15.0016 19.3024 15.2489 18.931 15.561 18.6181C15.8731 18.3051 16.2439 18.0569 16.6521 17.8875C17.0604 17.7181 17.498 17.6309 17.94 17.6309H100.41C100.852 17.6309 101.29 17.7181 101.698 17.8875C102.106 18.0569 102.477 18.3051 102.789 18.6181C103.101 18.931 103.348 19.3024 103.517 19.7111C103.685 20.1197 103.771 20.5576 103.77 20.9996V21.0009Z",
    fill: "#D2D2D2",
    stroke: "#CACACA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1801 10.5898V23.0398",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1801 10.5898V23.0398",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5499 11.4209C91.0912 11.4209 91.5299 10.9822 91.5299 10.4409C91.5299 9.8997 91.0912 9.46094 90.5499 9.46094C90.0087 9.46094 89.5699 9.8997 89.5699 10.4409C89.5699 10.9822 90.0087 11.4209 90.5499 11.4209Z",
    fill: "#CFCFCF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M29.31 12.2803C29.8512 12.2803 30.29 11.8416 30.29 11.3003C30.29 10.7591 29.8512 10.3203 29.31 10.3203C28.7687 10.3203 28.33 10.7591 28.33 11.3003C28.33 11.8416 28.7687 12.2803 29.31 12.2803Z",
    fill: "#CFCFCF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.39 4.81055V9.11055",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.24 6.96094H56.54",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31006 0.929688V5.22969",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16003 3.08008H11.47",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1329 34C57.9549 33.9978 53.8702 35.2346 50.3953 37.5541C46.9204 39.8736 44.2114 43.1715 42.6111 47.0308C41.0107 50.89 40.5908 55.1372 41.4045 59.2351C42.2182 63.3331 44.2289 67.0976 47.1823 70.0526C50.1358 73.0077 53.8993 75.0204 57.9967 75.8363C62.0942 76.6522 66.3416 76.2346 70.2017 74.6363C74.0619 73.038 77.3613 70.3308 79.6826 66.8572C82.004 63.3835 83.243 59.2994 83.243 55.1215C83.243 49.5217 81.0193 44.1511 77.0607 40.1904C73.1021 36.2296 67.7327 34.003 62.1329 34Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1598 70.4434L82.7892 76.0727",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1528 73.3379L80.4039 75.1674C79.6199 75.9875 79.6492 77.2879 80.4693 78.0719L95.6467 92.5807C96.4668 93.3647 97.7671 93.3354 98.5511 92.5153L100.3 90.6858C101.084 89.8657 101.055 88.5654 100.235 87.7814L85.0572 73.2725C84.2371 72.4886 82.9368 72.5178 82.1528 73.3379Z",
    fill: "#D2D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEvent);
export default __webpack_public_path__ + "static/media/NoEvent.1faf71f12d0a1363541dcf27eea53d17.svg";
export { ForwardRef as ReactComponent };